import React, { useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import LandingPageNavbar from "./LandingPageNavbar";
import LandingPageFooter from "./LandingPageFooter";
import { createCheckoutSession, getSubscriptionPlans } from "../../rtk/thunks/paymentsThunk";
import { trackBeginCheckout } from "../../utils/analytics";
import useResponsive from "../../hooks/useResponsive";


// Helper components for icons
const RocketIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6.2 21.8a2.2 2.2 0 0 1-2.2-2.2c0-2.3 1.2-4.8 2.5-6.8s2.3-3.8 2.3-5.3c0-1.4-1.1-2.5-2.5-2.5s-2.5 1.1-2.5 2.5c0 .4-.1.8-.2 1.2l-2-.5c-.2-.1-.4-.2-.5-.4a2.5 2.5 0 0 1 2.5-4.1c3.1 0 5.6 2.5 5.6 5.6 0 2.4-1.2 5-2.8 7.2-1.7 2.2-2.8 4.4-2.8 6.3z"></path><path d="M17.8 2.2a2.2 2.2 0 0 1 2.2 2.2c0 2.3-1.2 4.8-2.5 6.8s-2.3 3.8-2.3 5.3c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5c0-.4.1-.8.2-1.2l2 .5c.2.1.4.2.5.4a2.5 2.5 0 0 1-2.5 4.1c-3.1 0-5.6-2.5-5.6-5.6 0-2.4 1.2-5 2.8-7.2 1.7 2.2 2.8-4.4 2.8-6.3z"></path></svg>
);
const SearchIcon = () => (
  <svg xmlns="http://www.w.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
);
const LeadershipIcon = () =>
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2a2 2 0 0 0-2 2v2H8a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-2V4a2 2 0 0 0-2-2z" /><path d="M16 14a4 4 0 1 1-8 0" /></svg>
  ;
const AnalyticsIcon = () =>
  <svg width="170" height="171" viewBox="0 0 170 171" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M93.6284 25.9235C89.8542 19.1771 80.1458 19.1771 76.3716 25.9235C73.6545 30.7804 67.4657 32.4387 62.6842 29.5911C56.0424 25.6356 47.6346 30.4898 47.7393 38.2195C47.8147 43.7842 43.2842 48.3147 37.7195 48.2393C29.9898 48.1346 25.1356 56.5424 29.091 63.1842C31.9387 67.9657 30.2804 74.1545 25.4235 76.8716C18.6771 80.6458 18.6771 90.3542 25.4235 94.1284C30.2804 96.8455 31.9387 103.034 29.091 107.816C25.1356 114.458 29.9898 122.865 37.7195 122.761C43.2842 122.685 47.8147 127.216 47.7393 132.781C47.6346 140.51 56.0424 145.364 62.6842 141.409C67.4657 138.561 73.6545 140.22 76.3716 145.076C80.1458 151.823 89.8542 151.823 93.6284 145.076C96.3455 140.22 102.534 138.561 107.316 141.409C113.958 145.364 122.365 140.51 122.261 132.781C122.185 127.216 126.716 122.685 132.281 122.761C140.01 122.865 144.864 114.458 140.909 107.816C138.061 103.034 139.72 96.8455 144.576 94.1284C151.323 90.3542 151.323 80.6458 144.576 76.8716C139.72 74.1545 138.061 67.9657 140.909 63.1842C144.864 56.5424 140.01 48.1346 132.281 48.2393C126.716 48.3147 122.185 43.7842 122.261 38.2195C122.365 30.4898 113.958 25.6356 107.316 29.5911C102.534 32.4387 96.3455 30.7804 93.6284 25.9235Z" fill="#0D355C" fill-opacity="0.1" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M66.4444 58.5H104.556C107.562 58.5 110 60.9412 110 63.9527V105.268C110 109.045 106.259 111.678 102.711 110.399L98.4599 108.866C97.1315 108.387 95.6692 108.444 94.3816 109.024L87.7342 112.02C86.3134 112.66 84.6866 112.66 83.2658 112.02L76.6184 109.024C75.3308 108.444 73.8685 108.387 72.5401 108.866L68.2886 110.399C64.7407 111.678 61 109.045 61 105.268V63.9527C61 60.9412 63.4376 58.5 66.4444 58.5ZM74.6111 70.0869C73.4835 70.0869 72.5694 71.0024 72.5694 72.1317C72.5694 73.2609 73.4835 74.1764 74.6111 74.1764H85.5C86.6276 74.1764 87.5417 73.2609 87.5417 72.1317C87.5417 71.0024 86.6276 70.0869 85.5 70.0869H74.6111ZM74.6111 80.9922C73.4835 80.9922 72.5694 81.9077 72.5694 83.037C72.5694 84.1663 73.4835 85.0817 74.6111 85.0817H96.3889C97.5165 85.0817 98.4306 84.1663 98.4306 83.037C98.4306 81.9077 97.5165 80.9922 96.3889 80.9922H74.6111ZM74.6111 91.8976C73.4835 91.8976 72.5694 92.813 72.5694 93.9423C72.5694 95.0716 73.4835 95.9871 74.6111 95.9871H96.3889C97.5165 95.9871 98.4306 95.0716 98.4306 93.9423C98.4306 92.813 97.5165 91.8976 96.3889 91.8976H74.6111Z" fill="#0D355C" />
  </svg>

  ;
const ImprovementIcon = () =>
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20V10" /><path d="M18 20V4" /><path d="M6 20V16" /></svg>
  ;
const SafetyIcon = () =>
  <svg width="170" height="171" viewBox="0 0 170 171" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M93.6284 25.9235C89.8542 19.1771 80.1458 19.1771 76.3716 25.9235C73.6545 30.7804 67.4657 32.4387 62.6842 29.5911C56.0424 25.6356 47.6346 30.4898 47.7393 38.2195C47.8147 43.7842 43.2842 48.3147 37.7195 48.2393C29.9898 48.1346 25.1356 56.5424 29.091 63.1842C31.9387 67.9657 30.2804 74.1545 25.4235 76.8716C18.6771 80.6458 18.6771 90.3542 25.4235 94.1284C30.2804 96.8455 31.9387 103.034 29.091 107.816C25.1356 114.458 29.9898 122.865 37.7195 122.761C43.2842 122.685 47.8147 127.216 47.7393 132.781C47.6346 140.51 56.0424 145.364 62.6842 141.409C67.4657 138.561 73.6545 140.22 76.3716 145.076C80.1458 151.823 89.8542 151.823 93.6284 145.076C96.3455 140.22 102.534 138.561 107.316 141.409C113.958 145.364 122.365 140.51 122.261 132.781C122.185 127.216 126.716 122.685 132.281 122.761C140.01 122.865 144.864 114.458 140.909 107.816C138.061 103.034 139.72 96.8455 144.576 94.1284C151.323 90.3542 151.323 80.6458 144.576 76.8716C139.72 74.1545 138.061 67.9657 140.909 63.1842C144.864 56.5424 140.01 48.1346 132.281 48.2393C126.716 48.3147 122.185 43.7842 122.261 38.2195C122.365 30.4898 113.958 25.6356 107.316 29.5911C102.534 32.4387 96.3455 30.7804 93.6284 25.9235Z" fill="#0D355C" fill-opacity="0.1" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M59 66.3072C59 61.9954 62.4922 58.5 66.8 58.5H103.2C107.508 58.5 111 61.9954 111 66.3072V94.9337C111 99.2455 107.508 102.741 103.2 102.741H86.95V108.596H92.8C93.877 108.596 94.75 109.47 94.75 110.548C94.75 111.626 93.877 112.5 92.8 112.5H77.2C76.123 112.5 75.25 111.626 75.25 110.548C75.25 109.47 76.123 108.596 77.2 108.596H83.05V102.741H66.8C62.4922 102.741 59 99.2455 59 94.9337V66.3072ZM80.45 94.9337C80.45 93.8558 81.323 92.9819 82.4 92.9819H87.6C88.677 92.9819 89.55 93.8558 89.55 94.9337C89.55 96.0117 88.677 96.8855 87.6 96.8855H82.4C81.323 96.8855 80.45 96.0117 80.45 94.9337Z" fill="#0D355C" />
  </svg>

  ;

const PopulationIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const ReviewIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 11l3 3L22 4" />
    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
  </svg>
);

const ComplianceIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);

;

export default function LandingPage() {
  // ---- Top-level state (hooks must only appear here) ----
  // Standalone page (no Sidebar/Navbar shell), so what matters is that every
  // section of this page agrees on the same breakpoint rather than matching
  // the app shell's own thresholds.
  const { isTablet } = useResponsive();
  const isMobile = isTablet; // hero breakpoint
  const isSmall = isTablet; // contact/pricing breakpoint

  // Testimonials carousel state
  const [startIndex, setStartIndex] = React.useState(0);
  const [isPaused, setIsPaused] = React.useState(false);
  const showCount = isTablet ? 1 : 2;

  // Hover states for interactive cards (WHY and DOMAINS)
  const [hoveredId, setHoveredId] = React.useState(null);
  const [hoveredDomainId, setHoveredDomainId] = React.useState(null);
  const [activeCheckoutKey, setActiveCheckoutKey] = React.useState(null);

  // Contact form state
  const [form, setForm] = React.useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    comment: "",
  });
  const [formSubmitted, setFormSubmitted] = React.useState(false);
  const [checkoutFormError, setCheckoutFormError] = React.useState("");

  // ---- DATA ----
  const whyCards = [
    {
      id: 1,
      title: "AI Study Planner",
      desc: "Create a personalized study path based on your goals, timeline, and learning progress.",
      icon: "/assets/why/study.png",
      bgShape: "/assets/why/whyshapes.png",
    },
    {
      id: 2,
      title: "Interactive Learning Content",
      desc: "Review CPHQ concepts through focused summaries, flashcards, short lessons, and exam-focused explanations.",
      icon: "/assets/why/study.png",
      bgShape: "/assets/why/whyshapes.png",
    },
    {
      id: 3,
      title: "Mock Exams",
      desc: "Practice with exam-style questions that help you build timing, confidence, and decision-making skills.",
      icon: "/assets/why/Mock.png",
      bgShape: "/assets/why/whyshapes.png",
    },
    {
      id: 4,
      title: "Performance Dashboard",
      desc: "Track your progress across modules, question types, and healthcare quality topics.",
      icon: "/assets/why/performancedashboard.png",
      bgShape: "/assets/why/whyshapes.png",
    },
    {
      id: 5,
      title: "AI Tutor",
      desc: "Ask questions anytime and get simple explanations for difficult CPHQ concepts, scenarios, and answer choices.",
      icon: "/assets/why/aitutor.png",
      bgShape: "/assets/why/whyshapes.png",
    },
    {
      id: 6,
      title: "Readiness Meter",
      desc: "Understand your preparation level with AI-based insights that highlight strengths, weak areas, and topics needing review.",
      icon: "/assets/why/readness.png",
      bgShape: "/assets/why/whyshapes.png",
    },
  ];
  const domainCards = [
    {
      id: "org-lead",
      title: "Quality Leadership and Integration",
      desc: "Learn how leadership, ethics, strategy, and quality culture support better healthcare outcomes.",
      icon: <LeadershipIcon />,
    },
    {
      id: "perf-improvement",
      title: "Performance and Process Improvement",
      desc: "Study key improvement tools such as PDSA, Lean, Six Sigma, RCA, and process mapping.",
      icon: <ImprovementIcon />,
    },
    {
      id: "population-health",
      title: "Population Health and Care Transitions",
      desc: "Understand population health, care coordination, health equity, and safe patient transitions.",
      icon: <PopulationIcon />,
    },
    {
      id: "analytics",
      title: "Health Data Analytics",
      desc: "Learn how to use healthcare data, indicators, dashboards, and trends to improve performance.",
      icon: <AnalyticsIcon />,
    },
    {
      id: "patient",
      title: "Patient Safety",
      desc: "Focus on error prevention, safety culture, risk reduction, incident reporting, and safer care systems.",
      icon: <SafetyIcon />,
    },
    {
      id: "quality-review",
      title: "Quality Review and Accountability",
      desc: "Study review processes, utilization review, peer review, monitoring, and accountability in healthcare quality.",
      icon: <ReviewIcon />,
    },
    {
      id: "regulatory",
      title: "Regulatory and Accreditation",
      desc: "Understand compliance, accreditation standards, survey readiness, and regulatory requirements.",
      icon: <ComplianceIcon />,
    },
  ];

  const testimonials = [
    {
      id: 1,
      name: "Dr. Sara Ahmed",
      role: "Healthcare Quality Manager",
      rating: 5,
      avatarUrl: "https://i.imgur.com/vz92H2c.png",
      text:
        "Nexorah helped me organize my CPHQ preparation with clear modules, practice questions, and performance tracking. It made my study plan much more focused.",
    },
    {
      id: 2,
      name: "Aisha Martin",
      role: "Patient Safety Officer",
      rating: 5,
      avatarUrl: "https://i.imgur.com/vz92H2c.png",
      text:
        "The scenario-based MCQs were very useful because they connected CPHQ concepts with real healthcare quality situations.",
    },
    {
      id: 3,
      name: "Omar Al-Farsi",
      role: "Quality Improvement Specialist",
      rating: 5,
      avatarUrl: "https://i.imgur.com/vz92H2c.png",
      text:
        "I liked how Nexorah showed my weak areas and helped me review the topics that needed more attention before the exam.",
    },
    {
      id: 4,
      name: "Fatima Al-Mansoori",
      role: "Nurse Quality Coordinator",
      rating: 5,
      avatarUrl: "https://i.imgur.com/vz92H2c.png",
      text:
        "The AI study support made difficult topics easier to understand. The platform felt practical, simple, and designed for busy healthcare professionals.",
    },
  ];





  const staticPricingCards = [
    {
      id: "three-months",
      badge: "Early Bird Offer",
      title: "Early Bird Plan",
      price: 99,
      regularPrice: 169,
      periodText: "/3 months",
      subtitle: "Special early bird access for healthcare professionals preparing for the CPHQ exam with a structured 65-hour guided study path, complete learning modules, extensive question practice, AI support, mock exams, and performance tracking.",
      features: [
        { text: "Full access to all 7 CPHQ preparation modules", included: true },
        { text: "13+ hours of video lectures", included: true },
        { text: "315+ chapter-wise knowledge check MCQs", included: true },
        { text: "1,000+ exam-style MCQs, including module-wise practice and mock exams", included: true },
        { text: "Scenario-based practice questions", included: true },
        { text: "AI Study Planner for structured exam preparation", included: true },
        { text: "Mock exams to improve confidence and time management", included: true },
        { text: "Performance dashboard to track progress", included: true },
        { text: "Weak-area identification for focused review", included: true },
        { text: "Readiness meter to monitor exam preparation level", included: true },
        { text: "AI Tutor Chat for concept support and explanations", included: true },
        { text: "Flashcards, summaries, and interactive learning content", included: true },
        { text: "Approximately 65 hours of total guided preparation", included: true },
        { text: "3 months of full platform access", included: true },
      ],
      cta: { label: "Get Early Bird Access", style: "primary" },
      note: "Early bird price available for a limited time. Regular price $169.",
    },
  ];

  function formatPlanPeriod(duration) {
    const durationMap = {
      monthly: "/1 month",
      quarterly: "/3 months",
      yearly: "/1 year",
    };

    return durationMap[duration] || `/${duration || "plan"}`;
  }

  function formatPlanPrice(price) {
    const numericPrice = Number(price);
    return Number.isNaN(numericPrice) ? price : numericPrice.toFixed(0);
  }

  function getPlanId(plan) {
    return plan?.id ?? plan?._id ?? plan?.plan_id;
  }

  function normalizePlanText(value) {
    return String(value || "").toLowerCase().replace(/[^a-z0-9]/g, "");
  }

  function getThreeMonthPlan(plans) {
    return plans.find((plan) => {
      const planText = normalizePlanText([
        plan.duration,
        plan.name,
        plan.title,
        plan.description,
      ].filter(Boolean).join(" "));

      return plan.duration === "quarterly" || planText.includes("3month") || planText.includes("threemonth");
    }) || plans[0];
  }

  function getCheckoutUrl(checkoutSession) {
    return (
      checkoutSession?.checkout_url ||
      checkoutSession?.checkoutUrl ||
      checkoutSession?.url ||
      checkoutSession?.data?.checkout_url ||
      checkoutSession?.data?.url
    );
  }

  // ---- Helpers ----
  function Stars({ value = 5 }) {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      const filled = i <= value;
      stars.push(
        <span key={i} style={{ color: filled ? "#FF9800" : "#E0E0E0", fontSize: '24px' }}>
          ★
        </span>
      );
    }
    return <div style={{ display: "flex", gap: 4 }}>{stars}</div>;
  }

  function Avatar({ name, url }) {
    if (url) return <img src={url} alt={name} style={{ width: "50px", height: "50px", borderRadius: '50%', objectFit: "cover" }} />;
    const initials = (name || "U").split(" ").map((n) => n[0]).slice(0, 2).join("").toUpperCase();
    return <div style={{ width: "50px", height: "50px", borderRadius: '50%', background: '#E0E0E0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, color: "#0f172a", fontSize: 14 }}>{initials}</div>;
  }

  // ---- Carousel behavior ----
  const maxIndex = Math.max(0, testimonials.length - showCount);

  const next = React.useCallback(() => {
    setStartIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
  }, [maxIndex]);

  const prev = React.useCallback(() => {
    setStartIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
  }, [maxIndex]);

  React.useEffect(() => {
    if (isPaused) return;
    const id = setInterval(() => {
      next();
    }, 5000);
    return () => clearInterval(id);
  }, [next, isPaused]);

  // --- Scroll to hash when landing page is navigated with a hash fragment ---
  const location = useLocation();
  const locationHash = location.hash;
  React.useEffect(() => {
    if (!locationHash) return;
    const id = locationHash.replace('#', '');
    // small delay to ensure DOM elements are rendered
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 40);
  }, [locationHash]);

  React.useEffect(() => {
    function onKey(e) {
      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [next, prev]);

  const translatePercent = -(startIndex * (100 / showCount));

  // ---- Styling objects (inline) ----
  const heroStyles = {
    section: {
      width: "100%",
      background: "linear-gradient(to right, #FBFBFB 0%, #eef8ffff 5%, #FBFBFB 50%, #e9f5fdff 95%, #FBFBFB 100%)",
      padding: isMobile ? "36px 18px" : "64px 24px",
      boxSizing: "border-box",
      display: "flex",
      justifyContent: "center",
      // These values seem more like overall section properties rather than font styles
      // width: "100%", // already 100%
      // height: "auto", // section height is dynamic based on content
      // padding-top: 175px; // Overrides existing padding if applied directly here.
      // padding-right: 60px;
      // padding-bottom: 100px;
      // padding-left: 60px;
      // If you explicitly want to override the section padding, uncomment and adjust:
      // paddingTop: "175px",
      // paddingRight: "60px",
      // paddingBottom: "100px",
      // paddingLeft: "60px",
    },
    inner: {
      width: "100%",
      maxWidth: 1200,
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "1fr 520px",
      gap: isMobile ? 20 : 40,
      alignItems: "center",
    },
    content: { paddingRight: isMobile ? 0 : 12 },
    heading: {
      // Montserrat Bold for "CPHQ PREPARATION POWERED BY AI"
      fontFamily: "Montserrat, sans-serif", // Specify Montserrat
      fontSize: isMobile ? 28 : 44,
      lineHeight: isMobile ? 1.06 : 1.22,
      fontWeight: 700, // This generally implies "Bold" for Montserrat
      color: "#071128",
      margin: "0 0 18px 0",
      letterSpacing: "-0.02em",
    },
    highlight: {
      fontFamily: "Montserrat, sans-serif", // Ensure consistency for the highlight
      color: "#071128",
      fontWeight: 700, // Keep it bold
    },
    sub: {
      // Montserrat Regular with Montserrat's typography details
      fontFamily: "Montserrat, sans-serif", // Changed to Montserrat as specified for this text
      fontWeight: 400, // Regular
      fontStyle: "normal", // Regular (normal)
      fontSize: "20px", // Updated from 14/16px
      lineHeight: "30px", // Updated from 1.6
      letterSpacing: "0%", // Updated to 0%
      // leading-trim: NONE; vertical-align: middle; - these are not standard CSS properties
      color: "#5F6C76", // Keep existing color
      maxWidth: 570,
      marginBottom: isMobile ? 18 : 22,
    },
    imageWrap: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      width: "100%",
    },
    imageCard: {
      width: "100%",
      maxWidth: 520,
      borderRadius: 14,
      padding: 12,
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      overflow: "visible",
    },
    illustration: {
      width: "100%",
      height: "auto",
      display: "block",
      borderRadius: 8,
      boxShadow: "0 10px 30px rgba(2,10,25,0.06)",
      background: "#fff",
      position: "relative",
      zIndex: 1,
    },
    overlayDots: {
      position: "absolute",
      top: "-2%",
      right: "-6px",
      width: "19%",
      zIndex: 0,
    },
    overlayBg: {
      position: "absolute",
      bottom: "-2%",
      left: "-15px",
      width: "65%",
      zIndex: 0,
    },
  };


  const whyStyles = {
    section: {
      padding: isMobile ? "36px 14px" : "48px 16px",
      maxWidth: 1200,
      margin: "0 auto",
      fontFamily: "'Montserrat', sans-serif",
      background: "#FBFBFB",
      boxSizing: "border-box",
    },
    headerRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      marginBottom: 20,
      gap: 12,
      flexWrap: "wrap", // responsive
    },
    heading: {
      fontSize: "clamp(22px, 4vw, 32px)",
      lineHeight: 1.2,
      margin: 0,
      fontWeight: 700,
      color: "#0b1226",
      fontFamily: "'Montserrat Bold', 'Montserrat', sans-serif",
    },
    subtitle: {
      margin: 0,
      color: "#6b7280",
      fontSize: "clamp(12px, 2vw, 14px)",
      marginTop: 6,
      fontFamily: "'Montserrat Regular', 'Montserrat', sans-serif",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: isMobile ? "minmax(0, 1fr)" : "repeat(auto-fit, minmax(300px, 1fr))",
      gap: isMobile ? 14 : 18,
      marginTop: 18,
    },
    card: {
      background: "#ffffff",
      border: "1px solid #e6eaf0",
      borderRadius: 12,
      padding: isMobile ? "20px 16px" : "22px 18px",
      display: "flex",
      flexDirection: "column", // ✅ vertical layout
      alignItems: "flex-start", // left aligned
      boxSizing: "border-box",
      minHeight: isMobile ? 170 : 200,
      transition:
        "transform 220ms cubic-bezier(.2,.9,.2,1), box-shadow 220ms cubic-bezier(.2,.9,.2,1), border-color 220ms ease, background-color 220ms ease, color 220ms ease",
      boxShadow: "0 1px 0 rgba(13,18,25,0.02)",
      outline: "none",
      cursor: "pointer",
      flex: "1 1 auto",
    },
    cardHover: {
      transform: "translateY(-4px) scale(1.01)",
      boxShadow: "0 12px 30px rgba(15, 23, 42, 0.18)",
      borderColor: "#0D355C",
      background: "#0D355C",
      color: "#ffffff",
    },
    iconWrap: {
      width: isMobile ? 54 : 60,
      height: isMobile ? 54 : 60,
      marginBottom: 14, // ✅ space below icon
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    },
    iconWrapHover: {
      transform: "translateY(-2px)",
    },
    bgShape: {
      position: "absolute",
      width: "100%",
      height: "100%",
      objectFit: "contain",
      zIndex: 0,
    },
    icon: {
      position: "relative",
      zIndex: 1,
      width: isMobile ? "150px" : "220px",
      height: isMobile ? "42px" : "50px",
      marginRight: isMobile ? "-118px" : "-188px",
      marginTop: isMobile ? "22px" : "30px",
      objectFit: "contain",
    },
    title: {
      fontSize: "clamp(15px, 2vw, 16px)",
      fontWeight: 700,
      margin: "0 0 6px",
      color: "inherit",
      fontFamily: "'Montserrat Bold', 'Montserrat', sans-serif",
    },
    desc: {
      margin: 0,
      fontSize: "clamp(12px, 1.5vw, 13px)",
      color: "inherit",
      opacity: 0.5,
      lineHeight: 1.4,
      maxWidth: "100%",
      fontFamily: "'Montserrat Regular', 'Montserrat', sans-serif",
    },
    ctaButton: {
      background: "#2691ff",
      color: "#fff",
      border: "none",
      padding: "10px 16px",
      borderRadius: 8,
      cursor: "pointer",
      fontWeight: 600,
      fontSize: "clamp(13px, 2vw, 14px)",
      fontFamily: "'Montserrat Bold', 'Montserrat', sans-serif",
      boxShadow: "0 6px 18px rgba(38,145,255,0.16)",
      whiteSpace: "nowrap",
    },

    trustLIne :{
      fontSize: "clamp(12px, 1.5vw, 13px)",
      color: "#0D355C",
      opacity: 0.8,
      textAlign: "center",
      gridColumn: "1 / -1",
      justifySelf: "center",
      width: "100%",
      marginTop: isMobile ? "20px" : "30px",
      fontFamily: "'Montserrat Regular', 'Montserrat', sans-serif",
    }
  };



  const domainStyles = {
    section: { padding: isMobile ? "48px 14px" : "80px 24px", background: "#FBFBFB" },
    container: { maxWidth: 1200, margin: "0 auto" },
    header: { textAlign: "center", marginBottom: isMobile ? "28px" : "40px" },
    eyebrow: { display: "inline-block", background: "#D6E6FF", color: "#3DA9FC", padding: "6px 14px", borderRadius: 999, fontSize: "14px", fontWeight: "bold", marginBottom: "16px" },
    heading: { fontSize: isMobile ? "28px" : "36px", fontWeight: 600, margin: "0 0 16px 0", color: "#000000", lineHeight: 1.2 },
    sub: { color: "#000000", fontSize: isMobile ? "15px" : "18px", lineHeight: 1.6, maxWidth: "700px", margin: "0 auto", fontWeight: 400 },
    grid: { display: "grid", gridTemplateColumns: isMobile ? "minmax(0, 1fr)" : "repeat(2, 1fr)", gap: isMobile ? "16px" : "24px", marginTop: isMobile ? "28px" : "40px" },
    card: {
      background: "#FFFFFF",
      border: "1px solid #E2E8F0",
      color: "#1A202C",
      padding: isMobile ? "22px" : "32px",
      borderRadius: isMobile ? "12px" : "16px",
      transition: "transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease, color 0.3s ease",
      cursor: "pointer",
    },
    cardHover: {
      transform: "translateY(-5px)",
      boxShadow: "0 10px 20px rgba(0, 0, 0, 0.1)",
      background: "#0D224D",
      color: "#FFFFFF",
    },
    iconWrap: {
      width: "64px",
      height: "64px",
      borderRadius: "12px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "24px",
      overflow: "hidden",
      backgroundImage: "url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='%23E2E8F0FF' stroke-width='2' stroke-dasharray='6%2c 10' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e\")",
      color: "#4A5568", // Default icon color
      transition: "color 0.3s ease",
    },
    iconWrapHover: {
      backgroundImage: "url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='rgba(255%2c255%2c255%2c0.3)' stroke-width='2' stroke-dasharray='6%2c 10' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e\")",
      color: "#FFFFFF", // Icon color on hover
    },
    domainTitle: { fontSize: isMobile ? "20px" : "24px", fontWeight: "bold", margin: "0 0 12px 0", color: "inherit", lineHeight: 1.25 },
    domainDesc: { fontSize: isMobile ? "14px" : "16px", lineHeight: 1.6, opacity: 0.9, color: "inherit" },
  };


  const testimonialStyles = {
    section: {
      padding: isMobile ? "44px 14px" : "80px 24px",
      background: "#0D355C1A",
    },



    container: {
      width: "100%",
      maxWidth: 1200,
      margin: "0 auto",
      boxSizing: "border-box",
    },
    header: {
      textAlign: "center",
      marginBottom: isMobile ? "28px" : "40px",
    },
    eyebrow: {
      display: "inline-block",
      background: "#D6E6FF",
      color: "#3DA9FC",
      padding: "6px 14px",
      borderRadius: 999,
      fontSize: "14px",
      fontWeight: "bold",
      marginBottom: "16px",
    },
    heading: {
      fontSize: isMobile ? "28px" : "36px",
      fontWeight: 600,
      margin: 0,
      color: "#1A202C",
    },
    sliderWrap: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      padding: isMobile ? '0 34px' : '0 40px'
    },
    trackContainer: {
      overflow: "hidden",
      width: "100%",
    },
    track: {
      display: "flex",
      gap: isMobile ? "0px" : "24px",
      transition: "transform 500ms cubic-bezier(.25,.8,.25,1)",
      willChange: "transform",
    },
    card: {
      background: "#fff",
      borderRadius: isMobile ? "10px" : "12px",
      padding: isMobile ? "18px" : "32px",
      boxSizing: "border-box",
      boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
      flexShrink: 0,
    },
    cardHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: isMobile ? 'stretch' : 'flex-start',
      flexDirection: isMobile ? 'column' : 'row',
      gap: isMobile ? '12px' : 0,
      marginBottom: isMobile ? '16px' : '20px',
      margin: 0,
      fontSize: isMobile ? "16px" : "18px",
      fontWeight: 700,
      color: "#1A202C",
    },
    role: {
      margin: "4px 0 0 0",
      fontSize: isMobile ? "13px" : "14px",
      color: "#718096",
    },
    quote: {
      margin: 0,
      color: "#5F6C76",
      fontSize: isMobile ? "14px" : "16px",
      lineHeight: isMobile ? "24px" : "32px",
      Weight: 400,
    },
    navButton: {
      background: "white",
      border: "1px solid #E2E8F0",
      cursor: "pointer",
      width: isMobile ? "32px" : "40px",
      height: isMobile ? "32px" : "40px",
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 10,
      color: '#4A5568',
      boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
    },
    navLeft: {
      left: isMobile ? '0px' : '0px',
    },
    navRight: {
      right: isMobile ? '0px' : '0px',
    },
    dotsContainer: {
      display: 'none',
    }
  };

  const pricingStyles = {
    section: { padding: isMobile ? "44px 14px" : "56px 24px", background: "#FBFBFB", display: "flex", justifyContent: "center" },
    container: { width: "100%", maxWidth: 1200, boxSizing: "border-box", textAlign: "center" },
    eyebrow: {
      display: "inline-block", background: "#D6E6FF",
      color: "#3DA9FC", padding: "6px 12px", borderRadius: 999, fontSize: 12, marginBottom: 12
    },
    heading: { fontSize: isMobile ? 24 : 28, fontWeight: 700, margin: "6px 0 28px", color: "#000000", lineHeight: 1.15 },
    grid: { display: "grid", gridTemplateColumns: "minmax(0, 420px)", gap: isMobile ? 16 : 20, alignItems: "stretch", justifyContent: "center" },
    card: { background: "#ffffff", border: "1px solid #dbe7f3", borderRadius: 12, padding: isMobile ? "24px 18px" : "30px 28px", boxSizing: "border-box", minHeight: isMobile ? 0 : 430, display: "flex", flexDirection: "column", alignItems: "stretch", justifyContent: "space-between", boxShadow: "0 14px 34px rgba(15,23,42,0.08)" },
    tierLabel: { fontSize: 20, fontWeight: 800, color: "#0b1226", letterSpacing: 0, marginBottom: 14, textAlign: "left" },
    priceWrap: { display: "flex", alignItems: "baseline", gap: 8, textAlign: "left", marginBottom: 8 },
    priceAmount: { fontSize: isMobile ? 32 : 36, fontWeight: 800, color: "#0b1226", lineHeight: 1 },
    regularPrice: { fontSize: isMobile ? 18 : 20, fontWeight: 700, color: "#94a3b8", textDecoration: "line-through", lineHeight: 1.1 },
    priceBadge: {
      display: "inline-block",
      background: "#EAF4FF",
      color: "#1e88ff",
      border: "1px solid #cfe4ff",
      borderRadius: 999,
      padding: "6px 12px",
      fontSize: 12,
      fontWeight: 700,
      marginBottom: 12,
      textAlign: "left",
      alignSelf: "flex-start",
    },
    pricePeriod: { fontSize: 14, color: "#475569", marginLeft: 6 },
    priceSub: { fontSize: 13, color: "#64748b", marginBottom: 18, textAlign: "left" },
    featureList: { listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 12, marginBottom: 22, textAlign: "left" },
    featureRow: { display: "flex", gap: 12, alignItems: "center" },
    checkCircle: { width: 18, height: 18, borderRadius: 999, display: "inline-flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
    featureText: { fontSize: 13, color: "#0b1226" },
    ctaPrimary: { background: "linear-gradient(90deg,#1e88ff,#42b0ff)", color: "#fff", border: "none", padding: "12px 16px", borderRadius: 8, cursor: "pointer", fontWeight: 700, width: "100%", boxShadow: "0 8px 24px rgba(38,145,255,0.12)" },
    ctaDark: { background: "#0b3b5a", color: "#fff", border: "none", padding: "12px 16px", borderRadius: 8, cursor: "pointer", fontWeight: 700, width: "100%", boxShadow: "0 8px 24px rgba(11,59,90,0.12)" },
    smallNote: { marginTop: 12, fontSize: 12, color: "#94a3b8" },
  };

  const contactStyles = {
    section: {
      padding: isSmall ? "40px 16px 120px 16px" : "80px 24px 220px 24px", // extra bottom padding for card
      backgroundColor: "#FBFBFB",
      position: "relative",
      overflow: "visible",
    },
    inner: {
      maxWidth: "1200px",
      margin: "0 auto",
      display: "grid",
      gridTemplateColumns: isSmall ? "1fr" : "1fr 1fr",
      alignItems: "center",
      gap: isSmall ? "0" : "48px",
      background: "#0D355CED",
      backgroundImage: `linear-gradient(rgba(13, 34, 77, 0.85), rgba(13, 34, 77, 0.85)), url('/assets/contact_img.png')`,

      backgroundSize: "cover",
      backgroundPosition: "center",
      borderRadius: "16px",
      position: "relative",
      overflow: "visible",
      minHeight: isSmall ? "auto" : "400px",
    },
    leftPanel: {
      padding: isSmall ? "40px" : "64px",
      color: "#FFFFFF",
      position: "relative",
    },
    leftBadge: {
      display: "inline-block",
      background: "rgba(255, 255, 255, 0.12)",
      color: "#F8FAFC",
      padding: "8px 14px",
      borderRadius: "999px",
      fontSize: "12px",
      fontWeight: 700,
      letterSpacing: "0.08em",
      textTransform: "uppercase",
      marginBottom: "18px",
    },
    heading: {
      fontSize: isSmall ? "32px" : "42px",
      fontWeight: "bold",
      lineHeight: 1.2,
      margin: "0 0 14px 0",
    },
    subheading: {
      margin: "0",
      color: "rgba(255, 255, 255, 0.88)",
      fontSize: isSmall ? "15px" : "17px",
      lineHeight: 1.65,
      maxWidth: "560px",
    },
    highlight: {
      color: "#FFD700",
    },
    ctasRow: {
      display: "flex",
      flexDirection: isSmall ? "column" : "row",
      gap: "16px",
      marginTop: "24px",
      flexWrap: "wrap",
    },
    primaryBtn: {
      background: "linear-gradient(90deg, #0D224D 0%, #123B7A 100%)",
      color: "#FFFFFF",
      border: "1px solid rgba(255, 255, 255, 0.3)",
      padding: "12px 24px",
      borderRadius: "8px",
      cursor: "pointer",
      fontWeight: "bold",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
      fontSize: "15px",
      minWidth: isSmall ? "100%" : "214px",
      flex: isSmall ? "none" : "1 1 214px",
      boxShadow: "0 12px 26px rgba(13, 34, 77, 0.22)",
    },
    secondaryBtn: {
      background: "rgba(255, 255, 255, 0.12)",
      color: "#FFFFFF",
      border: "1px solid rgba(255, 255, 255, 0.22)",
      padding: "12px 24px",
      borderRadius: "8px",
      cursor: "pointer",
      fontWeight: "bold",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
      fontSize: "15px",
      minWidth: isSmall ? "100%" : "214px",
      flex: isSmall ? "none" : "1 1 214px",
      boxShadow: "0 12px 26px rgba(0, 0, 0, 0.12)",
    },
    playCircle: {
      position: "absolute",
      left: "-10px",
      bottom: "-10px",
      width: "72px",
      height: "72px",
      borderRadius: "50%",
      background: "rgba(41, 121, 255, 0.8)",
      display: isSmall ? "none" : "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "2px solid rgba(255, 255, 255, 0.2)",
    },
    playTriangle: {
      width: 0,
      height: 0,
      borderLeft: "16px solid white",
      borderTop: "10px solid transparent",
      borderBottom: "10px solid transparent",
      marginLeft: "4px",
    },
    dotsDecorator: {
      position: "absolute",
      top: "40px",
      left: "40px",
      width: "80px",
      height: "80px",
      backgroundImage: "radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px)",
      backgroundSize: "8px 8px",
      display: isSmall ? "none" : "block",
    },
    formCardWrapper: {
      position: "relative",
      // REMOVE alignItems and vertical centering!
      height: isSmall ? "auto" : "400px", // give space for absolute child
      display: 'block',
      zIndex: 3,
    },
    formCard: {
      background: "#FFFFFF",
      borderRadius: isSmall ? "0 0 12px 12px" : "12px",
      padding: isSmall ? "28px 22px" : "36px 34px",
      boxShadow: "0 28px 60px 0 rgba(0,0,0,0.20)",
      width: isSmall ? "100%" : "430px",
      minHeight: isSmall ? "auto" : "540px",
      height: isSmall ? "auto" : "540px",
      boxSizing: 'border-box',
      position: isSmall ? "static" : 'absolute',
      left: isSmall ? "0" : "50%",
      transform: isSmall ? "none" : "translateX(-50%)",
      bottom: isSmall ? "0" : "-80px", // overflow only bottom!
      zIndex: 5,
      top: isSmall ? "0" : "40px",
      // REMOVE TOP PROPERTY IF PRESENT
    },
    formHeading: {
      fontSize: isSmall ? "20px" : "22px",
      fontWeight: "bold",
      color: "#0D224D",
      marginBottom: "18px",
      textAlign: "center",
    },
    formNote: {
      marginTop: "12px",
      padding: "10px 12px",
      borderRadius: "10px",
      background: "#F8FBFF",
      border: "1px solid #E6F0FF",
      fontSize: "12px",
      lineHeight: 1.5,
      color: "#64748b",
      textAlign: "center",
      fontWeight: 500,
    },
    input: {
      width: "100%",
      padding: "14px 15px",
      borderRadius: "10px",
      border: "1px solid #D9E6F6",
      backgroundColor: "#F8FBFF",
      boxSizing: "border-box",
      fontSize: "15px",
      marginBottom: "16px",
    },
    smallRow: {
      display: "flex",
      flexDirection: isSmall ? "column" : "row",
      gap: "16px",
    },
    textarea: {
      width: "100%",
      padding: "14px 15px",
      borderRadius: "10px",
      border: "1px solid #D9E6F6",
      backgroundColor: "#F8FBFF",
      boxSizing: "border-box",
      fontSize: "15px",
      minHeight: isSmall ? "100px" : "140px",
      resize: "vertical",
      marginBottom: "16px",
    },
    signupBtn: {
      background: "linear-gradient(90deg, #2979FF 0%, #4EA1FF 100%)",
      color: "#FFFFFF",
      border: "none",
      padding: "14px 24px",
      borderRadius: "10px",
      cursor: "pointer",
      fontWeight: "bold",
      fontSize: "16px",
      width: "100%",
      boxShadow: "0 12px 24px rgba(41, 121, 255, 0.18)",
      marginTop: "4px",
    },
  };


  // ---- Form handlers ----
  function handleChange(e) {
    const { name, value } = e.target;
    setForm((s) => ({ ...s, [name]: value }));
    if (formSubmitted) setFormSubmitted(false);
  }

  function handleSubmit(e) {
    e.preventDefault();
    setForm({ name: "", email: "", phone: "", address: "", comment: "" });
    setFormSubmitted(true);
  }


  // here pricing
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const accessToken = useSelector((state) => state.auth?.access_token);
  const isLoggedIn = Boolean(accessToken || localStorage.getItem("access_token"));
  const { subscriptionPlans, loading, error, checkoutLoading, checkoutError } = useSelector((state) => state.payment);
  React.useEffect(() => {
    dispatch(getSubscriptionPlans());
  }, [dispatch]);

  const subscriptionPlanOptions = Array.isArray(subscriptionPlans) ? subscriptionPlans : [];

  async function handleCheckout(tier, subscriptionPlan) {
    const planId = getPlanId(subscriptionPlan);
    setCheckoutFormError("");

    if (!isLoggedIn) {
      navigate("/sign-up", { state: { from: "/#pricing-heading", intent: "checkout" } });
      return;
    }

    if (!planId) {
      setCheckoutFormError("Please select a subscription duration first.");
      return;
    }

    const checkoutKey = `${tier.id}-${planId}`;
    setActiveCheckoutKey(checkoutKey);

    try {
      const checkoutSession = await dispatch(createCheckoutSession({
        plan_id: planId,
        success_url: `${window.location.origin}/payment/success`,
        cancel_url: `${window.location.origin}/payment/cancel`,
      })).unwrap();

      const checkoutUrl = getCheckoutUrl(checkoutSession);

      if (checkoutUrl) {
        trackBeginCheckout({
          planId,
          planName: subscriptionPlan?.name || subscriptionPlan?.title || "Subscription",
          value: subscriptionPlan?.price ?? tier?.price,
        });
        window.location.href = checkoutUrl;
        return;
      }

      setCheckoutFormError("Checkout URL not found in response.");
    } catch (checkoutErrorPayload) {
      const authMissing =
        checkoutErrorPayload?.detail === "Authentication credentials were not provided." ||
        checkoutErrorPayload?.status === 401 ||
        checkoutErrorPayload?.code === "not_authenticated";
      if (authMissing) {
        navigate("/sign-up", { state: { from: "/#pricing-heading", intent: "checkout" } });
        return;
      }
      setCheckoutFormError(
        checkoutErrorPayload?.detail ||
        checkoutErrorPayload?.error ||
        "Unable to create checkout session."
      );
    } finally {
      setActiveCheckoutKey(null);
    }
  }

  // ---- Render ----
  return (
    <div style={{ fontFamily: "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial", background: '#f6f8fc' }}>
      <LandingPageNavbar />

      <main>
        {/* HERO */}
        <section style={heroStyles.section} aria-labelledby="hero-heading">
          <div style={heroStyles.inner}>
            <div style={heroStyles.content}>
              <h1 id="hero-heading" style={heroStyles.heading}>
                CPHQ Exam Preparation
                <br />
                <span style={heroStyles.highlight}>Powered by AI</span>
              </h1>
              <p style={heroStyles.sub}>
                Prepare smarter for the CPHQ exam with structured learning, exam-style practice, and AI-driven performance insights.              </p>
            </div>

            <div style={heroStyles.imageWrap} aria-hidden>
              <div style={heroStyles.imageCard}>
                {/* Background dots behind hero */}
                <img
                  src="/assets/dots.png"
                  alt="Decorative dots"
                  style={heroStyles.overlayDots}
                  onError={(e) => {
                    e.currentTarget.src =
                      "https://via.placeholder.com/200x200.png?text=Dots";
                  }}
                />

                {/* New background image */}
                <img
                  src="/assets/bg.png"
                  alt="Decorative background shape"
                  style={heroStyles.overlayBg}
                  onError={(e) => {
                    e.currentTarget.src =
                      "https://via.placeholder.com/200x200.png?text=Bg";
                  }}
                />

                {/* Main hero image */}
                <img
                  src="/assets/hero.png"
                  alt="Dashboard preview"
                  style={heroStyles.illustration}
                  onError={(e) => {
                    e.currentTarget.src =
                      "https://via.placeholder.com/520x320.png?text=Dashboard+Preview";
                  }}
                />
              </div>
            </div>
          </div>
        </section>
        {/* WHY CHOOSE */}
        <section style={whyStyles.section} aria-labelledby="why-choose-heading">
          <div style={whyStyles.headerRow}>
            <div>
              <h2 id="why-choose-heading" style={whyStyles.heading}>
                Why Choose Nexorah?
              </h2>
              <p style={whyStyles.subtitle}>
                Built for busy healthcare professionals preparing for CPHQ.
              </p>
            </div>
            <div>
              <button style={whyStyles.ctaButton} aria-label="All Categories">
                All Categories →
              </button>
            </div>
          </div>

          <div style={whyStyles.grid}>
            {whyCards.map((c) => {
              const isHovered = hoveredId === c.id;
              return (
                <article
                  key={c.id}
                  style={{
                    ...whyStyles.card,
                    ...(isHovered ? whyStyles.cardHover : {}),
                  }}
                  onMouseEnter={() => setHoveredId(c.id)}
                  onMouseLeave={() => setHoveredId(null)}
                  onFocus={() => setHoveredId(c.id)}
                  onBlur={() => setHoveredId(null)}
                  role="button"
                  tabIndex={0}
                  aria-labelledby={`card-${c.id}-title`}
                >
                  <div
                    style={{
                      ...whyStyles.iconWrap,
                      ...(isHovered ? whyStyles.iconWrapHover : {}),
                    }}
                    aria-hidden
                  >
                    <img src={c.bgShape} alt="" style={whyStyles.bgShape} />
                    <img src={c.icon} alt="" style={whyStyles.icon} />
                  </div>
                  <h3 id={`card-${c.id}-title`} style={whyStyles.title}>
                    {c.title}
                  </h3>
                  <p style={whyStyles.desc}>{c.desc}</p>
                </article>
              );
            })}

            <h3 style={whyStyles.trustLIne} >Designed around CPHQ exam domains, healthcare quality concepts, and scenario-based practice.</h3>
          </div>
        </section>

        {/* DOMAINS */}
        <section style={domainStyles.section} aria-labelledby="domains-heading">
          <div style={domainStyles.container}>
            <div style={domainStyles.header}>
              <div style={domainStyles.eyebrow}>What You'll Learn</div>
              <h2 id="domains-heading" style={domainStyles.heading}>Full Coverage of NAHQ Domains</h2>
              <p style={domainStyles.sub}>
                Explore topic-wise modules designed to match the NAHQ framework and ensure complete readiness for the CPHQ exam.
              </p>
            </div>
            <div style={domainStyles.grid}>
              {domainCards.map((d) => {
                const isHovered = hoveredDomainId === d.id;
                return (
                  <article
                    key={d.id}
                    style={{ ...domainStyles.card, ...(isHovered ? domainStyles.cardHover : {}) }}
                    onMouseEnter={() => setHoveredDomainId(d.id)}
                    onMouseLeave={() => setHoveredDomainId(null)}
                    onFocus={() => setHoveredDomainId(d.id)}
                    onBlur={() => setHoveredDomainId(null)}
                    tabIndex={0}
                    aria-labelledby={`domain-${d.id}-title`}
                  >
                    <div style={{ ...domainStyles.iconWrap, ...(isHovered ? domainStyles.iconWrapHover : {}) }} aria-hidden="true">
                      {d.icon}
                    </div>
                    <div>
                      <h3 id={`domain-${d.id}-title`} style={domainStyles.domainTitle}>{d.title}</h3>
                      <p style={domainStyles.domainDesc}>{d.desc}</p>
                    </div>
                  </article>
                );
              })}
            </div>
          </div>
        </section>


        {/* TESTIMONIALS */}
        <section
          style={testimonialStyles.section}
          aria-labelledby="testimonials-heading"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <div style={testimonialStyles.container}>
            <div style={testimonialStyles.header}>
              <div style={testimonialStyles.eyebrow}>Feedback</div>
              <h2 id="testimonials-heading" style={testimonialStyles.heading}>STUDENTS TESTIMONIALS</h2>
            </div>

            <div style={testimonialStyles.sliderWrap}>
              <button aria-label="Previous testimonials" onClick={prev} style={{ ...testimonialStyles.navButton, ...testimonialStyles.navLeft }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15 18l-6-6 6-6" /></svg>
              </button>

              <div style={testimonialStyles.trackContainer}>
                <div role="list" style={{ ...testimonialStyles.track, transform: `translateX(${translatePercent}%)` }}>
                  {testimonials.map((t) => {
                    const cardWidth = `calc((100% - ${(showCount - 1) * 24}px) / ${showCount})`;
                    return (
                      <div key={t.id} role="listitem" style={{ ...testimonialStyles.card, flexBasis: cardWidth }}>
                        <div style={testimonialStyles.cardHeader}>
                          <div style={testimonialStyles.authorInfo}>
                            <Avatar name={t.name} url={t.avatarUrl} />
                            <div>
                              <p style={testimonialStyles.name}>{t.name}</p>
                              <p style={testimonialStyles.role}>{t.role}</p>
                            </div>
                          </div>
                          <Stars value={t.rating} />
                        </div>
                        <p style={testimonialStyles.quote}>{t.text}</p>
                      </div>
                    );
                  })}
                </div>
              </div>

              <button aria-label="Next testimonials" onClick={next} style={{ ...testimonialStyles.navButton, ...testimonialStyles.navRight }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6" /></svg>
              </button>
            </div>
            <div style={testimonialStyles.dotsContainer} />
          </div>
        </section>

        {/* PRICING */}
        <section style={pricingStyles.section} aria-labelledby="pricing-heading">
          <div style={pricingStyles.container}>
            <div style={{ textAlign: "center" }}>
              <div style={pricingStyles.eyebrow}>Pricing Plan</div>
              <h2 id="pricing-heading" style={pricingStyles.heading}>Choose The Best Package<br />For your Learning</h2>
            </div>
            {loading && subscriptionPlanOptions.length === 0 && (
              <p style={{ color: "#64748b", fontSize: 14, margin: "0 0 18px" }}>
                Loading subscription plans...
              </p>
            )}
            {error && subscriptionPlanOptions.length === 0 && (
              <p style={{ color: "#dc2626", fontSize: 14, margin: "0 0 18px" }}>
                {error.detail || "Unable to load subscription plans."}
              </p>
            )}
            {checkoutError && (
              <p style={{ color: "#dc2626", fontSize: 14, margin: "0 0 18px" }}>
                {checkoutError.detail || checkoutError.error || "Unable to create checkout session."}
              </p>
            )}
            {checkoutFormError && (
              <p style={{ color: "#dc2626", fontSize: 14, margin: "0 0 18px" }}>
                {checkoutFormError}
              </p>
            )}
            {!loading && !error && subscriptionPlanOptions.length === 0 && (
              <p style={{ color: "#64748b", fontSize: 14, margin: "0 0 18px" }}>
                Duration plans are not available yet.
              </p>
            )}
            <div style={pricingStyles.grid}>
              {staticPricingCards.map((p) => {
                const selectedSubscriptionPlan = getThreeMonthPlan(subscriptionPlanOptions);
                const selectedSubscriptionPlanId = getPlanId(selectedSubscriptionPlan);
                const checkoutKey = `${p.id}-${selectedSubscriptionPlanId}`;
                const isActiveCheckout = checkoutLoading && activeCheckoutKey === checkoutKey;
                const displayPrice = p.price;
                const displayPeriod = p.periodText;
                const displaySubtitle = p.subtitle;
                const displayRegularPrice = p.regularPrice;

                return (
                  <div key={p.id} style={pricingStyles.card} aria-labelledby={`tier-${p.id}`}>
                    <div>
                      <div style={pricingStyles.priceBadge}>{p.badge}</div>
                      <div style={pricingStyles.tierLabel} id={`tier-${p.id}`}>{p.title}</div>
                      <div style={pricingStyles.priceWrap}>
                        <div style={pricingStyles.priceAmount}>${displayPrice}</div>
                        <div style={pricingStyles.regularPrice}>${displayRegularPrice}</div>
                        <div style={pricingStyles.pricePeriod}>{displayPeriod}</div>
                      </div>
                      <div style={pricingStyles.priceSub}>{displaySubtitle}</div>
                      <ul style={pricingStyles.featureList}>
                        {p.features.map((f, idx) => (
                          <li key={idx} style={pricingStyles.featureRow}>
                            <div style={{ ...pricingStyles.checkCircle, background: f.included ? "#e6f3ff" : "#eef2f7", border: f.included ? "2px solid #1e88ff" : "2px solid #cbd5e1", color: f.included ? "#1e88ff" : "#64748b" }}>
                              {f.included ? (
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden><path d="M20 6L9 17l-5-5" stroke="#1e88ff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" /></svg>
                              ) : (
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden><path d="M18 6L6 18M6 6l12 12" stroke="#64748b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                              )}
                            </div>
                            <div style={pricingStyles.featureText}>{f.text}</div>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <button
                        onClick={() => handleCheckout(p, selectedSubscriptionPlan)}
                        disabled={checkoutLoading || !selectedSubscriptionPlan}
                        style={{
                          ...(p.cta.style === "primary" ? pricingStyles.ctaPrimary : pricingStyles.ctaDark),
                          opacity: isActiveCheckout || !selectedSubscriptionPlan ? 0.65 : 1,
                          cursor: checkoutLoading || !selectedSubscriptionPlan ? "not-allowed" : "pointer",
                        }}
                        aria-label={`${p.title} - ${p.cta.label}`}
                      >
                        {isActiveCheckout ? "Redirecting..." : p.cta.label}
                      </button>
                      <div style={pricingStyles.smallNote}>{p.note}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* CONTACT SECTION */}
        <section style={contactStyles.section} aria-labelledby="contact-heading">
          <div style={contactStyles.inner}>
            <div style={contactStyles.leftPanel}>
              <div style={contactStyles.dotsDecorator} aria-hidden="true"></div>
              <div style={contactStyles.leftBadge}>Course</div>
              <h2 id="contact-heading" style={contactStyles.heading}>
                Get Started With Your <br />
                <span style={contactStyles.highlight}>AI-Powered </span> CPHQ Journey
              </h2>
              <p style={contactStyles.subheading}>
                Join Nexorah and prepare with structured CPHQ modules, exam-style practice, AI support, and progress tracking.
              </p>
              <div style={contactStyles.ctasRow}>
                <button
                  type="button"
                  style={contactStyles.primaryBtn}
                  onClick={() => {
                    if (isLoggedIn) {
                      document.getElementById("pricing-heading")?.scrollIntoView({ behavior: "smooth" });
                      return;
                    }
                    navigate("/sign-up", { state: { from: "/#pricing-heading", intent: "checkout" } });
                  }}
                >
                  <RocketIcon /> Get Early Bird Access
                </button>
                <button style={contactStyles.secondaryBtn}><SearchIcon /> View Dashboard Demo</button>
              </div>
              <div style={contactStyles.playCircle} aria-hidden="true">
                <div style={contactStyles.playTriangle} />
              </div>
            </div>
            <div style={contactStyles.formCardWrapper}>
              <form onSubmit={handleSubmit} style={contactStyles.formCard} aria-label="Register for Early Bird Access">
                <h3 style={contactStyles.formHeading}>Register for Early Bird Access</h3>
                <input name="name" value={form.name} onChange={handleChange} placeholder="Your Name" style={contactStyles.input} />
                <div style={contactStyles.smallRow}>
                  <input name="email" value={form.email} onChange={handleChange} placeholder="Email Address" style={contactStyles.input} />
                  <input name="phone" value={form.phone} onChange={handleChange} placeholder="Phone" style={contactStyles.input} />
                </div>
                <input name="address" value={form.address} onChange={handleChange} placeholder="Address" style={contactStyles.input} />
                <textarea name="comment" value={form.comment} onChange={handleChange} placeholder="Comment" style={contactStyles.textarea} />
                <button type="submit" style={contactStyles.signupBtn}>Submit Registration →</button>
                {formSubmitted && (
                  <div style={{ color: "#16A34A", fontSize: 14, fontWeight: 600, marginTop: "10px" }}>
                    Thanks! We've received your registration and will be in touch shortly.
                  </div>
                )}
                <div style={contactStyles.formNote}>Early bird access: $99 for 3 months. Regular price: $169.</div>
              </form>
            </div>
          </div>
        </section>
      </main>

      <LandingPageFooter />
    </div>
  );
}
